import { render } from "./FirstAnniversaryForFanScreen.vue?vue&type=template&id=1c96e527&scoped=true&ts=true&lang=pug"
import script from "./FirstAnniversaryForFanScreen.vue?vue&type=script&lang=ts"
export * from "./FirstAnniversaryForFanScreen.vue?vue&type=script&lang=ts"

import "./FirstAnniversaryForFanScreen.vue?vue&type=style&index=0&id=1c96e527&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c96e527"]])

export default __exports__